jQuery(document).ready(function () {
    jQuery('.product-teaser.hidden').slice(0, 4).removeClass('hidden');

    jQuery('.load-more-products').click(function() {
        jQuery('.product-teaser.hidden').slice(0, 4).removeClass('hidden');

        if (jQuery('.product-teaser.hidden').length === 0) {
            jQuery('.load-more-action-wrap').remove();
        }
    });
});